<template>
  <div class="option_item" :class="className">
    <div class="serial_no flex_center">
        <CheckboxInput
            v-if="iconType === 'checkbox'"
            v-model="checkbox_value"
            :classNameWrapper="'form_builder_check'"
        />
        <CheckboxInput
            v-if="iconType === 'radio'"
            v-model="checkbox_value"
            :classNameWrapper="'form_builder_check'"
            :iconName="'radio'"
        />
        <div
            v-if="iconType === 'numbering'"
            class="paragraph font_regular flex_center"
        >
            {{serialNo}}.
        </div>
    </div>
    <div class="option_body">
        <input
            class="input_field my_0"
            :value="value"
            type="text"
            :placeholder="`Option ${serialNo}`"
            @input="$emit('input', $event.target.value)"
        >
    </div>
    <div class="option_action">
      <woot-button
        variant="smooth"
        color-scheme="secondary"
        icon="dismiss"
        size="small"
        class-names="margin-right-button"
        @click="onDeleteOption"
        />
    </div>
  </div>
</template>

<script>
import CheckboxInput from "components/ui/inputs/CheckboxInput.vue";

export default {
    components: {
        CheckboxInput,
    },
    props:{
        value: {
            type: [String, Number],
            // required: true,
            default: null,
        },
        index: {
            type: Number,
        },
        serialNo: {
            type: Number,
        },
        className: {
            type: String,
        },
        iconType: {
          type: String,
          default: 'checkbox'  // checkbox, radio, numbering
        },
    },
    data(){
        return {
          checkbox_value: false
        }
    },
    methods:{
        onDeleteOption(){
            this.$emit('onDeleteOption', this.index);
        },
    }
}
</script>


<style lang="scss" scoped>
.option_item{
    display: flex;
    gap: 10px;
}
.serial_no{
    width: 50px;
}
.option_body{
    flex: 1;
}
.option_action{
    width: 50px;
}
</style>

<style scoped>
.form_builder_check{
    margin-bottom: 0;
}
</style>